import { Select } from '@factorialco/f0-react/dist/experimental'

import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { FormCycle } from 'modules/forms'

interface Props {
  cycles: FormCycle[]
  selectedCycleId: string | null
  onCycleChange: (cycleId: string | null) => void
  placeholder?: string
  label?: string
}

const formatCycleLabel = (cycle: FormCycle) => {
  const startDate = i18nDateToString(new Date(cycle.startsAt), 'ui_date_day_month_year')
  const endDate = cycle.endsAt
    ? i18nDateToString(new Date(cycle.endsAt), 'ui_date_day_month_year')
    : '-'
  return `${startDate} → ${endDate}`
}

export const CycleSelector = ({
  cycles,
  selectedCycleId,
  onCycleChange,
  placeholder = i18n.t('surveys.cycles.select_placeholder'),
  label,
}: Props) => {
  const options = cycles.map((cycle) => ({
    label: formatCycleLabel(cycle),
    value: cycle.id,
  }))

  return (
    <Select
      label={label || i18n.t('surveys.cycles.label')}
      hideLabel={!label}
      placeholder={placeholder}
      showSearchBox
      searchEmptyMessage={i18n.t('surveys.cycles.no_cycles_available')}
      value={selectedCycleId || ''}
      onChange={(value) => onCycleChange(value || null)}
      options={options}
    />
  )
}
